<template>
<div>
    <img :src="imgUrl" />
    <p>感谢您对我们工作的支持！</p>
    <p>您已成功的更新了相应信息！</p>
</div>
    
</template>
<script>
export default {
    name:'reviewSuccess',
    data(){
        return {
            currentRate:0,
            rate:100,
            imgUrl: process.env.BASE_URL + "img/success.jpg"
        }
    },
    mounted(){
        this.currentRate = 100;
    }
    
}
</script>
<style scoped>
div{
    padding-top:20%; 
    text-align: center;
}
p{
    text-align: center;
    color:#222;
}
img{
    width:5rem;
}


</style>